export default __webpack_public_path__ + "static/media/comment-icon.b1c56635.svg";